import { observer } from "mobx-react-lite";

import { usePageStore } from "../../create-application-page.lib";
import { CreateApplicationAdjacentObjectDataStep } from "./create-application-adjacent-object-data-step";
import { CreateApplicationCrossingObjectDataStep } from "./create-application-crossing-object-data-step";

type CreateApplicationObjectDataStepProps = {
  className?: string;
};

export const CreateApplicationObjectDataStep = observer(({ className }: CreateApplicationObjectDataStepProps) => {
  const pageStore = usePageStore();

  if (pageStore?.selectedCategory === "crossing") {
    return <CreateApplicationCrossingObjectDataStep className={className} />;
  }

  return <CreateApplicationAdjacentObjectDataStep className={className} />;
});
